import React from 'react';
import '../template-file-css/document-file-template.css';


export const MC_IntakeAssessment = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='MC_IntakeAssessment' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><center><h3>TYPE OF SERVICE</h3></center></p>
                <table>
                    <tr>
                        <td className='w-750'><b>Select all that apply</b></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbScreeningAssessment' name='cbScreeningAssessment' className='add-only' value='ScreeningAssessment' /> Screening/Assessment</td>
                        <td className='w-250'><input type='checkbox' id='cbOutpatientTherapy' name='cbOutpatientTherapy' className='add-only' value='OutpatientTherapy' /> Outpatient Therapy</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbTypeOfServiceOther' name='cbTypeOfServiceOther' className='add-only' value='TypeOfServiceOther' /> Other : &nbsp;
                            <input type='text' id='txtTypeOfServiceOther' name='txtTypeOfServiceOther' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><center><h3>PATIENT INFORMATION</h3></center></p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Patient Full Name</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtPatientFullName' name='txtPatientFullName' className='add-only' placeholder='(First, Middle, Last)' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Preferred Name </span><span className='small'>(likes to be called)</span></td>
                        <td className='w-375'><span className='eleHeader'>Social Security #</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtPatientPreferredName' name='txtPatientPreferredName' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtPatientSsn' name='txtPatientSsn' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Physical Address</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtPatientPhysicalAddress' name='txtPatientPhysicalAddress' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Mailing, if different</span></td>
                        <td className='w-375'><span className='eleHeader'>County</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtPatientMailing' name='txtPatientMailing' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtPatientCounty' name='txtPatientCounty' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Primary Phone#</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtPatientPrimaryPhone' name='txtPatientPrimaryPhone' className='add-only w-350 custom-add-only' /> &nbsp;
                            <input type='radio' id='rbPatientPrimaryPhoneHome' name='rbPatientPrimaryPhone' className='add-only' value='Home' /> Home &nbsp;
                            <input type='radio' id='rbPatientPrimaryPhoneWork' name='rbPatientPrimaryPhone' className='add-only' value='Work' /> Work &nbsp;
                            <input type='radio' id='rbPatientPrimaryPhoneCell' name='rbPatientPrimaryPhone' className='add-only' value='Cell' /> Cell
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Secondary Phone#</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtPatientSecondaryPhone' name='txtPatientSecondaryPhone' className='add-only w-350 custom-add-only' /> &nbsp;
                            <input type='radio' id='rbPatientSecondaryPhoneHome' name='rbPatientSecondaryPhone' className='add-only' value='Home' /> Home &nbsp;
                            <input type='radio' id='rbPatientSecondaryPhoneWork' name='rbPatientSecondaryPhone' className='add-only' value='Work' /> Work &nbsp;
                            <input type='radio' id='rbPatientSecondaryPhoneCell' name='rbPatientSecondaryPhone' className='add-only' value='Cell' /> Cell
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Allergies</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbPatientAllergiesYes' name='rbPatientAllergies' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbPatientAllergiesNo' name='rbPatientAllergies' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>If “yes”, please provide details: </b>
                            <input type='text' id='txtPatientAllergiesDetails' name='txtPatientAllergiesDetails' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <br />

                <p className='w-750'><center><h3>DEMOGRAPHIC INFORMATION</h3></center>
                    <span className='small'>Select all that apply:</span></p>

                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Age</span></td>
                        <td className='w-500'><span className='eleHeader'>Sex</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id='txtDemographicAge' name='txtDemographicAge' className='add-only' /></td>
                        <td className='w-500'>
                            <input type='radio' id='bDemographicSex□Female' name='rbDemographicSex' className='add-only' value='Female' /> Female &nbsp;
                            <input type='radio' id='rbDemographicSexMale' name='rbDemographicSex' className='add-only' value='Male' /> Male &nbsp;
                            <input type='radio' id='rbDemographicSexOtherPreferNotDisclose' name='rbDemographicSex' className='add-only' value='OtherPreferNotDisclose' /> Other/Prefer Not to Disclose
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Marital Status</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbMaritalStatusSingle' name='rbMaritalStatus' className='add-only' value='Single' /> Single &nbsp;
                            <input type='radio' id='rbMaritalStatusMarried' name='rbMaritalStatus' className='add-only' value='Married' /> Married &nbsp;
                            <input type='radio' id='rbMaritalStatusDivorced' name='rbMaritalStatus' className='add-only' value='Divorced' /> Divorced &nbsp;
                            <input type='radio' id='rbMaritalStatusWidowed' name='rbMaritalStatus' className='add-only' value='Widowed' /> Widowed &nbsp;
                            <input type='radio' id='rbMaritalStatusSeparated' name='rbMaritalStatus' className='add-only' value='Separated' /> Separated
                        </td>
                    </tr>


                    <tr>
                        <td className='w-750'><span className='eleHeader'>Race</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbRaceAfricanAmerican' name='rbRace' className='add-only' value='AfricanAmerican' /> African American &nbsp;
                            <input type='radio' id='rbRaceNativeAmerican' name='rbRace' className='add-only' value='NativeAmerican' /> Native American &nbsp;
                            <input type='radio' id='rbRaceCaucasian' name='rbRace' className='add-only' value='Caucasian' /> Caucasian
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbRaceOther' name='rbRace' className='add-only' value='Other' /> Other &nbsp;
                            <input type='text' id='txtRaceOther' name='txtRaceOther' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>


                    <tr>
                        <td className='w-750'><span className='eleHeader'>Ethnicity</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbEthnicityNotHispanicOrigin' name='cbEthnicity' className='add-only' value='NotHispanicOrigin' /> Not Hispanic origin &nbsp;</td>
                        <td className='w-250'><input type='checkbox' id='cbEthnicityHispanicCuban' name='cbEthnicity' className='add-only' value='HispanicCuban' /> Hispanic, Cuban &nbsp;</td>
                        <td className='w-250'><input type='checkbox' id='cbEthnicityHispanicMexicanAmerican' name='cbEthnicity' className='add-only' value='HispanicMexicanAmerican' /> Hispanic, Mexican American</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbEthnicityHispanicPuertoRican' name='cbEthnicity' className='add-only' value='HispanicPuertoRican' /> Hispanic, Puerto Rican &nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbEthnicityHispanicOther' name='cbEthnicity' className='add-only' value='HispanicOther' /> Hispanic, Other &nbsp;
                            <input type='text' id='txtEthnicityHispanicOther' name='txtEthnicityHispanicOther' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Primary Language</span></td>
                        <td className='w-375'><span className='eleHeader'>Secondary Language, if applicable</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtPrimaryLanguage' name='txtPrimaryLanguage' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtSecondaryLanguage' name='txtSecondaryLanguage' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Highest Education Completed</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbHighestEducationCompletedElementaryGrade' name='rbHighestEducationCompleted' className='add-only' value='ElementaryGrade' /> Elementary Grade </td>
                        <td className='w-187'><input type='radio' id='rbHighestEducationCompletedMiddleSchoolGrade' name='rbHighestEducationCompleted' className='add-only' value='MiddleSchoolGrade' /> Middle School Grade </td>
                        <td className='w-187'><input type='radio' id='rbHighestEducationCompletedHighSchoolGrade' name='rbHighestEducationCompleted' className='add-only' value='HighSchoolGrade' /> High School Grade</td>
                        <td className='w-187'><input type='radio' id='rbHighestEducationCompletedCollege' name='rbHighestEducationCompleted' className='add-only' value='College' /> College</td>

                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbHighestEducationCompletedGed' name='rbHighestEducationCompleted' className='add-only' value='Ged' /> GED

                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <center><h3>SOURCE(S) OF INCOME</h3></center>
                            <center> <span className='small'>Select all that apply:</span> </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Employment Status</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbUnemployed' name='cbUnemployed' className='add-only' value='Unemployed' /> Unemployed</td>
                        <td className='w-250'><input type='checkbox' id='cbEmployedFullTime' name='cbEmployedFullTime' className='add-only' value='EmployedFullTime' /> Employed Full-Time</td>
                        <td className='w-250'><input type='checkbox' id='cbPartTime' name='cbPartTime' className='add-only' value='PartTime' /> Part-Time</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbStudent' name='cbStudent' className='add-only' value='Student' /> Student</td>
                        <td className='w-250'><input type='checkbox' id='cbRetired' name='cbRetired' className='add-only' value='Retired' /> Retired</td>
                        <td className='w-250'><input type='checkbox' id='cbHomemaker' name='cbHomemaker' className='add-only' value='Homemaker' /> Homemaker</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbAvailableWork' name='cbAvailableWork' className='add-only' value='AvailableWork' /> Available for Work</td>
                        <td className='w-500'><input type='checkbox' id='cbArmedForcesNationalGuard' name='cbArmedForcesNationalGuard' className='add-only' value='ArmedForcesNationalGuard' /> Armed Forces/National Guard</td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Veteran</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbVeteranYes' name='rbVeteran' className='add-only' value='Yes' /> Yes</td>
                        <td className='w-250'><input type='radio' id='rbVeteranNo' name='rbVeteran' className='add-only' value='No' /> No</td>
                        <td className='w-250'><input type='radio' id='rbVeteranUnknown' name='rbVeteran' className='add-only' value='Unknown' /> Unknown</td>
                    </tr>


                    <tr>
                        <td className='w-750'><span className='eleHeader'>Benefits/Supplemental Support</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbMedicare' name='cbMedicare' className='add-only' value='Medicare' /> Medicare</td>
                        <td className='w-250'><input type='checkbox' id='cbMedicaid' name='cbMedicaid' className='add-only' value='Medicaid' /> Medicaid</td>
                        <td className='w-250'><input type='checkbox' id='cbWagesSalary' name='cbWagesSalary' className='add-only' value='WagesSalary' /> Wages/Salary</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbFamilyRelative' name='cbFamilyRelative' className='add-only' value='FamilyRelative' /> Family or Relative</td>
                        <td className='w-250'><input type='checkbox' id='cbAlimony' name='cbAlimony' className='add-only' value='Alimony' /> Alimony</td>
                        <td className='w-250'><input type='checkbox' id='cbChildSupport' name='cbChildSupport' className='add-only' value='ChildSupport' /> Child Support</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbDisabledWorkersComp' name='cbDisabledWorkersComp' className='add-only' value='DisabledWorkersComp' /> Disabled/Workers Comp</td>
                        <td className='w-250'><input type='checkbox' id='cbUnemployment' name='cbUnemployment' className='add-only' value='Unemployment' /> Unemployment</td>
                        <td className='w-250'><input type='checkbox' id='cbSsi' name='cbSsi' className='add-only' value='Ssi' /> SSI</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbSsdi' name='cbSsdi' className='add-only' value='Ssdi' /> SSDI</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbBenefitsSupportOther' name='cbBenefitsSupportOther' className='add-only' value='BenefitsSupportOther' /> Other: &nbsp;
                            <input type='text' id='txtBenefitsSupportOther' name='txtBenefitsSupportOther' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Gross Annual Family Income</span></td>
                        <td className='w-375'><span className='eleHeader'>Family Size</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtGrossAnnualFamilyIncome' name='txtGrossAnnualFamilyIncome' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtFamilySize' name='txtFamilySize' className='add-only' /></td>
                    </tr>
                </table>


                <p className='w-750'><center><h3>BEHAVIORAL HEALTH HISTORY</h3></center></p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>History of Behavioral Health Issues</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbHistoryBehavioralHealthIssuesYes' name='rbHistoryBehavioralHealthIssues' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbHistoryBehavioralHealthIssuesNo' name='rbHistoryBehavioralHealthIssues' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Explain</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtBehavioralHealthHistoryExplain' name='txtBehavioralHealthHistoryExplain' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><center><h3>LEGALLY RESPONSIBLE PERSON (GUARDIAN) INFORMATION</h3></center></p>
                <p className='w-750'><center>Individual must show documentation of guardianship/legally responsible</center></p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Legally Responsible Person</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtLegallyResponsiblePerson' name='txtLegallyResponsiblePerson' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Physical Address</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtPhysicalAddress' name='txtPhysicalAddress' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Mailing, if different</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtMailingIfDifferent' name='txtMailingIfDifferent' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Primary Phone</span></td>
                        <td className='w-375'><span className='eleHeader'></span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtPrimaryPhone' name='txtPrimaryPhone' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtSecondaryPhone' name='txtSecondaryPhone' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><center><h3>INSURANCE INFORMATION</h3></center></p>

                <table>
                    <tr>
                        <td className='w-350'><span className='eleHeader'>Policy Holder Name</span></td>
                        <td className='w-150'><span className='eleHeader'>Date of Birth</span></td>
                        <td className='w-250'><span className='eleHeader'>SSN#</span></td>
                    </tr>
                    <tr>
                        <td className='w-350'><input type='text' id='txtPolicyHolderName' name='txtPolicyHolderName' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtDateOfBirth' name='txtDateOfBirth' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtSsn' name='txtSsn' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Insurance Company</span></td>
                        <td className='w-375'><span className='eleHeader'>Insurance ID#</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtInsuranceCompany' name='txtInsuranceCompany' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtInsuranceId' name='txtInsuranceId' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Claims Mailing Address</span></td>
                        <td className='w-375'><span className='eleHeader'>Claims Phone#</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtClaimsMailingAddress' name='txtClaimsMailingAddress' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtClaimsPhone' name='txtClaimsPhone' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><center><h3>ACKNOWLEDGEMENT OF FINANCIAL RESPONSIBILITY</h3></center></p>

                <p className='w-750'>
                    In order to establish optimal relations with our consumers and avoid misunderstandings regarding our payment policies, our staff
                    are trained to inform you of our financial policies. Payment is due at the time services are rendered (provided). Your signature
                    below shows that you read, understand, and have accepted this policy.
                    <br /><br />
                    My signature hereby authorizes treatment by the providers of Millennium Consulting, LLC. The fee for services has been made
                    available at my request.
                    <br /><br />
                    I hereby authorize Millennium Consulting, LLC to furnish information to my insurance company concerning my diagnosis and
                    treatment to request reimbursement for services provided. I understand that I am responsible for all fees not covered by insurance.
                    I further authorize insurance benefits to be paid directly to Millennium Consulting, LLC as my provider.
                </p>

                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Printed Name </td>
                        <td className='small w-375'> Relationship to Patient </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Signature </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>

                <p className='w-750'><center><h3>PATIENT PRIVACY DESIGNATIONS</h3></center></p>
                <p className='w-750'><b>Do we have permission to…?</b></p>

                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Leave a message at the phone number(s) that you provided?</span></td>
                        <td className='w-375'><span className='eleHeader'>Discuss your medical history/treatment with any other member of your household?</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbPermissionToLeaveMessageYes' name='rbPermissionToLeaveMessage' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbPermissionToLeaveMessageNo' name='rbPermissionToLeaveMessage' className='add-only' value='No' /> No
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbPermissionToDiscussMedicalHistoryYes' name='rbPermissionToDiscussMedicalHistory' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbPermissionToDiscussMedicalHistoryNo' name='rbPermissionToDiscussMedicalHistory' className='add-only' value='No' /> No
                        </td>
                    </tr>

                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Name </td>
                        <td className='small w-375'> Relation to Patient </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='small'>If yes, a current Release of Information Form must be completed and on file</span></td>
                    </tr>
                </table>

                <p className='w-750'><center><h3>EMERGENCY CONTACT INFORMATION</h3></center>
                    The information listed below is confidential and for <b>emergency use only</b>, as such, it may be used by Millennium Consulting, LLC and emergency
                    personnel. I give permission for my information to be released to emergency personnel. I also agree that my emergency contacts listed on this
                    sheet may be notified in an emergency, as needed.
                </p>

                <p className='w-750'><center><b>Primary person to be notified in case of an emergency</b></center></p>

                <table>
                    <tr>
                        <td className='w-350'><span className='eleHeader'>Name</span></td>
                        <td className='w-400'><span className='eleHeader'>Relationship</span></td>
                    </tr>
                    <tr>
                        <td className='w-350'><input type='text' id='txtPrimaryPersonName' name='txtPrimaryPersonName' className='add-only' /></td>
                        <td className='w-400'>
                            <input type='radio' id='rbPrimaryPersonRelationshipRelative' name='rbPrimaryPersonRelationship' className='add-only' value='Relative' /> Relative &nbsp;
                            <input type='radio' id='bPrimaryPersonRelationship□Friend' name='rbPrimaryPersonRelationship' className='add-only' value='Friend' /> Friend &nbsp;
                            <input type='radio' id='rbPrimaryPersonRelationshipOther' name='rbPrimaryPersonRelationship' className='add-only' value='Other' /> Other
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Home Address</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtPrimaryPersonHomeAddress' name='txtPrimaryPersonHomeAddress' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Home phone</span></td>
                        <td className='w-250'><span className='eleHeader'>Work Phone</span></td>
                        <td className='w-250'><span className='eleHeader'>Cell Phone</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id='txtPrimaryPersonHomePhone' name='txtPrimaryPersonHomePhone' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtPrimaryPersonWorkPhone' name='txtPrimaryPersonWorkPhone' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtPrimaryPersonCellPhone' name='txtPrimaryPersonCellPhone' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><center><b>Secondary person to be notified in case of an emergency</b></center></p>

                <table>
                    <tr>
                        <td className='w-350'><span className='eleHeader'>Name</span></td>
                        <td className='w-400'><span className='eleHeader'>Relationship</span></td>
                    </tr>
                    <tr>
                        <td className='w-350'><input type='text' id='txtSecondaryPersonName' name='txtSecondaryPersonName' className='add-only' /></td>
                        <td className='w-400'>
                            <input type='radio' id='rbSecondaryPersonRelationshipRelative' name='rbSecondaryPersonRelationship' className='add-only' value='Relative' /> Relative &nbsp;
                            <input type='radio' id='bSecondaryPersonRelationship□Friend' name='rbSecondaryPersonRelationship' className='add-only' value='Friend' /> Friend &nbsp;
                            <input type='radio' id='rbSecondaryPersonRelationshipOther' name='rbSecondaryPersonRelationship' className='add-only' value='Other' /> Other
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Home Address</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtSecondaryPersonHomeAddress' name='txtSecondaryPersonHomeAddress' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Home phone</span></td>
                        <td className='w-250'><span className='eleHeader'>Work Phone</span></td>
                        <td className='w-250'><span className='eleHeader'>Cell Phone</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id='txtSecondaryPersonHomePhone' name='txtSecondaryPersonHomePhone' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtSecondaryPersonWorkPhone' name='txtSecondaryPersonWorkPhone' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtSecondaryPersonCellPhone' name='txtSecondaryPersonCellPhone' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><center><b>Primary Physician Contact</b></center></p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Physician/Practice&#39;s Name</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtPrimaryPhysicianName' name='txtPrimaryPhysicianName' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Address</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtPrimaryPhysicianAddress' name='txtPrimaryPhysicianAddress' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Office Phone#</span></td>
                        <td className='w-250'><span className='eleHeader'>After-hours/Pager</span></td>
                        <td className='w-250'><span className='eleHeader'>Fax#</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id='txtPrimaryPhysicianOfficePhone' name='txtPrimaryPhysicianOfficePhone' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtPrimaryPhysicianAfterHoursPager' name='txtPrimaryPhysicianAfterHoursPager' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtPrimaryPhysicianFax' name='txtPrimaryPhysicianFax' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><center><b>Pharmacy Contact</b></center></p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Name of Pharmacy</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtPharmacyContactName' name='txtPharmacyContactName' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Address</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtPharmacyContactAddress' name='txtPharmacyContactAddress' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Phone#</span></td>
                        <td className='w-375'><span className='eleHeader'>Fax#</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtPharmacyContactOfficePhone' name='txtPharmacyContactOfficePhone' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtPharmacyContactFax' name='txtPharmacyContactFax' className='add-only' /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><center><h3>Admission Screening Assessment</h3>
                            <span className='small'>To be completed at time of Admission Screening</span></center></td>
                    </tr>

                    <tr>
                        <td className='w-500'><span className='eleHeader'>CLIENT NAME</span></td>
                        <td className='w-250'><span className='eleHeader'>DOB</span></td>
                    </tr>
                    <tr>
                        <td className='w-500'><input type='text' id='txtAsaClientName' name='txtAsaClientName' className='add-only' /></td>
                        <td className='w-250'><input type='Date' id='txtAsaDob' name='txtAsaDob' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>RECORD NUMBER</span></td>
                        <td className='w-375'><span className='eleHeader'>INSURANCE ID NUMBER</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtAsaRecordNumber' name='txtAsaRecordNumber' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtAsaInsuranceIdNumber' name='txtAsaInsuranceIdNumber' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Screening Interview Performed by </span>
                            <span className='small'>(Printed Name & Credentials or Title)</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtScreeningInterviewPerformed' name='txtScreeningInterviewPerformed' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>DATE</span></td>
                        <td className='w-250'><span className='eleHeader'>TIME</span></td>
                        <td className='w-250'><span className='eleHeader'>DURATION</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='date' id='txtScreeningInterviewDate' name='txtScreeningInterviewDate' className='add-only' /></td>
                        <td className='w-250'><input type='time' id='txtScreeningInterviewTime' name='txtScreeningInterviewTime' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtScreeningInterviewDuration' name='txtScreeningInterviewDuration' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>LOCATION</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbAsaLocationOffice' name='rbAsaLocation' className='add-only' value='Office' /> Office &nbsp;
                            <input type='radio' id='rbAsaLocationHome' name='rbAsaLocation' className='add-only' value='Home' /> Home &nbsp;
                            <input type='radio' id='rbAsaLocationCommunity' name='rbAsaLocation' className='add-only' value='Community' /> Community
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>ACCOMPANIED BY</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtAsaAccompaniedBy' name='txtAsaAccompaniedBy' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>REASON FOR ADMISSION AND PRESENTING PROBLEM</span>
                    <textarea id='txtReasonForAdmission' name='txtReasonForAdmission' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>STRENGTHS</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtAsaStrengths' name='txtAsaStrengths' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>NEEDS</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtAsaNeeds' name='txtAsaNeeds' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>ABILITIES</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtAsaAbilities' name='txtAsaAbilities' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>PERFERENCES</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtAsaPerferences' name='txtAsaPerferences' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>HISTORY OF ABUSE, NEGLECT, VIOLENCE, SELF-HARM</span>
                    <textarea id='txtHistoryOfSelfHarm' name='txtHistoryOfSelfHarm' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>LEGAL INVOLVEMENT</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtAsaLegalInvolvement' name='txtAsaLegalInvolvement' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>FAMILY HISTORY</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtAsaFamilyHistory' name='txtAsaFamilyHistory' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>MEDICAL HISTORY</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtAsaMedicalHistory' name='txtAsaMedicalHistory' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>IMMUNIZATION RECORD</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtAsaImmunizationRecord' name='txtAsaImmunizationRecord' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>PRENATAL EXPOSURE TO ALCOHOL, TOBACCO, OR OTHER DRUGS</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtAsaPrentalExposureToSubstances' name='txtAsaPrentalExposureToSubstances' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>DISABILITIES/DISORDER/MEDICAL CONCERNS</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtAsaDisabilitiesConcerns' name='txtAsaDisabilitiesConcerns' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>MEDICATIONS </span>
                    <span className='small'>(previous as well as current)</span>
                    <textarea id='txtMedicationsPreviousCurrent' name='txtMedicationsPreviousCurrent' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>BEHAVIORAL HEALTH/PSYCHIATRIC HISTORY</span>
                    <textarea id='txtBehavioralHistory' name='txtBehavioralHistory' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-187'><span className='eleHeader'>HEIGHT</span></td>
                        <td className='w-187'><span className='eleHeader'>WEIGHT</span></td>
                        <td className='w-187'><span className='eleHeader'>AGE</span></td>
                        <td className='w-187'><span className='eleHeader'>AFFECT</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='text' id='txtHeight' name='txtHeight' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtWeight' name='txtWeight' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtAge' name='txtAge' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtAffect' name='txtAffect' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-187'><span className='eleHeader'>MOOD</span></td>
                        <td className='w-187'><span className='eleHeader'>SPEECH</span></td>
                        <td className='w-187'><span className='eleHeader'>THOUGHTS</span></td>
                        <td className='w-187'><span className='eleHeader'>HEARING</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='text' id='txtMood' name='txtMood' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtSpeech' name='txtSpeech' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtThoughts' name='txtThoughts' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtHearing' name='txtHearing' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>ORIENTATION</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbOrientationPerson' name='rbOrientation' className='add-only' value='Person' /> Person</td>
                        <td className='w-187'><input type='radio' id='rbOrientationPlace' name='rbOrientation' className='add-only' value='Place' /> Place</td>
                        <td className='w-187'><input type='radio' id='rbOrientationTime' name='rbOrientation' className='add-only' value='Time' /> Time</td>
                        <td className='w-187'><input type='radio' id='rbOrientationSituation' name='rbOrientation' className='add-only' value='Situation' /> Situation</td>
                    </tr>
                    <tr>
                        <td className='w-187'><span className='eleHeader'>MEMORY</span></td>
                        <td className='w-187'><span className='eleHeader'>JUDGEMENT</span></td>
                        <td className='w-187'><span className='eleHeader'>ATT/CONCENT</span></td>
                        <td className='w-187'><span className='eleHeader'>APPETITE</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='text' id='txtMemory' name='txtMemory' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtJudgement' name='txtJudgement' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtConcent' name='txtConcent' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtAppetite' name='txtAppetite' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>SLEEP</span></td>
                        <td className='w-375'><span className='eleHeader'>EST. INTELLECT</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtSleep' name='txtSleep' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='radio' id='rbIntellectAverage' name='rbIntellect' className='add-only' value='Average' /> Average &nbsp;
                            <input type='radio' id='rbIntellectAbove' name='rbIntellect' className='add-only' value='Above' /> Above &nbsp;
                            <input type='radio' id='rbIntellectBelow' name='rbIntellect' className='add-only' value='Below' /> Below
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>LANGUAGE FUNCTIONING</span></td>
                        <td className='w-375'><span className='eleHeader'>VISION FUNCTIONING</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtLanguageFunctioning' name='txtLanguageFunctioning' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtVisionFunctioning' name='txtVisionFunctioning' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>PSYCHOTIC BEHAVIOR/THOUGHTS NOTED</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbPsychoticBehaviorNotedNo' name='rbPsychoticBehaviorNoted' className='add-only' value='No' /> NO &nbsp;
                            <input type='radio' id='rbPsychoticBehaviorNotedYes' name='rbPsychoticBehaviorNoted' className='add-only' value='Yes' /> YES
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>(If yes, please describe): </b>
                            <input type='text' id='txtPsychoticBehaviorNoted' name='txtPsychoticBehaviorNoted' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>IS CLIENT CURRENTLY A DANGER TO SELF OR OTHERS</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbClientDangerousToOthersNo' name='rbClientDangerousToOthers' className='add-only' value='No' /> NO &nbsp;
                            <input type='radio' id='rbClientDangerousToOthersYes' name='rbClientDangerousToOthers' className='add-only' value='Yes' /> YES
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>(If yes, please describe): </b>
                            <input type='text' id='txtClientDangerousToOthers' name='txtClientDangerousToOthers' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-150'><span className='eleHeader'>“Diagnosis by History”</span></td>
                        <td className='w-150'><span className='eleHeader'>Dx Code</span></td>
                        <td className='w-450'><span className='eleHeader'>DSM Diagnosis</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'><center><input type='checkbox' id='cbDiagnosisHistory_1' name='cbDiagnosisHistory_1' className='add-only' value='Yes' /> Yes</center></td>
                        <td className='w-150'><input type='text' id='txtDxCode_1' name='txtDxCode_1' className='add-only' /></td>
                        <td className='w-450'><input type='text' id='txtDsmDiagnosis_1' name='txtDsmDiagnosis_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><center><input type='checkbox' id='cbDiagnosisHistory_2' name='cbDiagnosisHistory_2' className='add-only' value='Yes' /> Yes</center></td>
                        <td className='w-150'><input type='text' id='txtDxCode_2' name='txtDxCode_2' className='add-only' /></td>
                        <td className='w-450'><input type='text' id='txtDsmDiagnosis_2' name='txtDsmDiagnosis_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><center><input type='checkbox' id='cbDiagnosisHistory_3' name='cbDiagnosisHistory_3' className='add-only' value='Yes' /> Yes</center></td>
                        <td className='w-150'><input type='text' id='txtDxCode_3' name='txtDxCode_3' className='add-only' /></td>
                        <td className='w-450'><input type='text' id='txtDsmDiagnosis_3' name='txtDsmDiagnosis_3' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><center><input type='checkbox' id='cbDiagnosisHistory_4' name='cbDiagnosisHistory_4' className='add-only' value='Yes' /> Yes</center></td>
                        <td className='w-150'><input type='text' id='txtDxCode_4' name='txtDxCode_4' className='add-only' /></td>
                        <td className='w-450'><input type='text' id='txtDsmDiagnosis_4' name='txtDsmDiagnosis_4' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><center><input type='checkbox' id='cbDiagnosisHistory_5' name='cbDiagnosisHistory_5' className='add-only' value='Yes' /> Yes</center></td>
                        <td className='w-150'><input type='text' id='txtDxCode_5' name='txtDxCode_5' className='add-only' /></td>
                        <td className='w-450'><input type='text' id='txtDsmDiagnosis_5' name='txtDsmDiagnosis_5' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>GAF, if assessed</b></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtGafIfAssessed' name='txtGafIfAssessed' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>ADJUSTMENT TO CONDITION/DISABILITY/DISORDER</span>
                    <textarea id='txtAdjustmentToDisorder' name='txtAdjustmentToDisorder' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>ATTITUDE ABOUT TREATMENT</span>
                    <textarea id='txtAttitudeAboutTreatment' name='txtAttitudeAboutTreatment' className='add-only' ></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>Plan for Discharge or Transition to a HIGHER or LOWER level of care </span>
                    <span className='small'>(When or If…)</span>
                    <textarea id='txtPlanForDischarge' name='txtPlanForDischarge' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Signature & Credentials/Title </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>

                <p className='w-750'><center><h3>Summary of Patient Acknowledgements</h3></center></p>

                <p className='w-750'><center><h1>Client Orientation Acknowledgement</h1></center>
                    <br />
                    Millennium Consulting LLC clients are empowered with certain rights and responsibilities, as described in the Client Rights and
                    Responsibilities Notice, to ensure that they are active, informed participants in their individualized plan of care. A client may
                    designate someone to act as his/her “client representative”. A client representative may exercise any of the rights provided by the
                    policies and procedures established by Millennium Consulting, LLC on behalf of the client. Upon admission, as a client of Millennium
                    Consulting, LLC, I will be instructed or given written materials regarding
                </p>

                <p className='w-750'>
                    <ul>
                        <li><b>Privacy -</b> Employees of Millennium Consulting, LLC must abide by the Health Insurance Portability and Accountability Act
                            (HIPAA), which governs all protected health information be kept confidential. We strive for complete satisfaction of the
                            person served. We do this by having 24-hour crisis line accessibility and professional staff that provide quality support for
                            the client to achieve desired therapeutic outcomes. <br /> <br /></li>
                        <li>Millennium Consulting, LLC abides by the following Code of Ethics <br /> <br /></li>

                        <ol type='A'>
                            <li><b>Client Welfare</b> - the primary responsibility is for clients to be treated with respect. Millennium Consulting, LLC encourages
                                growth and development in ways that foster the clients&#39; welfare and interest. Clients are encouraged to work jointly with their
                                clinical team to develop their Individualized Plan of Care. Millennium Consulting, LLC encourages family involvement and
                                natural supports, which creates a positive support system important to the client&#39;s optimal treatment outcomes. <br /> <br /></li>

                            <li><b>Respecting Diversity</b>- Millennium Consulting, LLC operates on a nondiscrimination policy. We respect differences and will
                                work diligently to understand the diverse cultural background of the clients we serve <br /> <br /></li>

                            <li><b>Client Rights</b>- The client has freedom of choices in who they would like to provide service to them. If a client or legal guardian
                                of a minor is unable to give consent, then Millennium Consulting, LLC Staff will act in the best interest of the client to ensure
                                their overall well-being.
                                <br /> <br /></li>

                            <li><b>Clients Served by others</b>- If a client is receiving services from another professional, Millennium Consulting, LLC, with client
                                consent, informs the professional person already involved and develops clear agreements to avoid confusion and conflict for
                                the client. <br /> <br /></li>

                            <li><b>Personal Needs and Values</b>- Millennium Consulting, LLC does not try to impose any personal beliefs or values on any clients <br /> <br /></li>

                            <li><b>Dual Relationships</b>- Millennium Consulting, LLC takes care to avoid any relationship that is not therapeutic and may cause
                                conflict in client treatment outcomes <br /> <br /></li>

                            <li><b>Sexual Intimacies with Clients</b> - Millennium Consulting, LLC personnel do not engage in any type of sexual or otherwise
                                inappropriate relationship with clients, including those that are no longer receiving services <br /> <br /></li>

                            <li><b>Multiple Clients</b>- Millennium Consulting, LLC will agree to provide therapeutic services to two or more persons with a
                                personal relationship (such as husband, wife, and children). Millennium Consulting, LLC will not disclose therapeutic
                                information to family members unless authorized by the client receiving services. <br /> <br /></li>

                            <li><b>Group Work</b>- Millennium Consulting, LLC will screen all participants. For those that have similar needs and goals and participate
                                in services provided in a group format, we will ensure the group process is not slowed by individual participants&#39;
                                actions/conduct and participants&#39; well-being is not jeopardized by the group experience.
                                <br /> <br /></li>

                            <li><b>Fees and Bartering</b>- Millennium Consulting, LLC informs consumer of their financial responsibilities prior to enrollment
                                in services. Millennium Consulting, LLC does not accept any goods from clients in return for therapeutic service. <br /> <br /></li>

                            <li><b>Termination and Referral</b>- Millennium Consulting, LLC does not abandon or neglect clients in treatment. If Millennium
                                Consulting, LLC staff are unable to engage a client in therapeutic treatment, due to the client not making him or herself
                                available, we reserve the right to consider terminating the therapeutic relationship. Millennium Consulting, LLC will terminate
                                the therapeutic relationship if the consumer no longer feels that he/she needs services <br /> <br /></li>

                        </ol>

                        <li>Millennium Consulting, LLC is a smoke-free environment. Millennium Consulting, LLC does not allow any type of illegal drug not
                            prescribed by a physician on the premises. Weapons are prohibited. Millennium Consulting, LLC, utilizes nonviolent practices and
                            intervention techniques in managing individuals in crisis. <br /> <br /></li>

                        <li>Millennium Consulting, LLC staff are mandated reporters. If any type of neglect or abuse is identified by law, we must report it to
                            the necessary authorities.
                            <br /> <br /></li>

                        <li>As a client of Millennium Consulting, LLC, you have the right to privacy, to be respected in a humane way, to review documentation
                            regarding treatment, to terminate services at any time, to be linked to the necessary treatment facility that correlates to your recovery,
                            and the right to 24-hour crisis intervention services. If any client feels that they have been exploited or treated unfairly, they have the
                            right to file a Grievance by contacting Millennium Consulting, LLC and speaking to their Case Manager or his/her supervisor. An
                            investigation will take place within 48 hours and a written report will be submitted to the owner. If the original grievance is not resolved
                            within 30 days, the client has the right to take the grievance to SC Governor&#39;s Advocacy Council for Person with Disabilities <br /> <br /></li>

                        <li>As a client of Millennium Consulting, LLC, you are responsible for <br /> <br /></li>
                        <ol type='a'>
                            <li>Attending all sessions with your assigned clinician/treatment team. Your treatment team will then set-up and coordinate the
                                treatment schedule with you. <br /> <br /></li>
                            <li>It is required that you arrive on time for all appointments and if you are unable to attend, you should notify your us within 24 hours
                                to cancel/reschedule the appointment. <br /> <br /></li>
                        </ol>

                        <li><b>Grounds for discharge:</b></li>
                        <ul>
                            <li>Death of client</li>

                            <li>Voluntary withdrawal or relocation</li>

                            <li>Client unavailable for services</li>

                            <li>Repeated no-show</li>

                            <li>Client/ family refusal of services</li>

                            <li>Non -compliances with program rules</li>

                            <li>Individual behaves in a manner deemed likely to cause physical harm to others or serious harm to self</li>

                            <li>Client unwillingness to pay for services</li>

                            <li>Services appropriate to client needs are unavailable</li>

                            <li>Client no longer meets eligibility criteria</li>

                            <li>Client ages out of services</li>

                            <li>Client condition deteriorated to the extent that services of greater intensity are necessary to protect the individual&#39;s safety and security</li>

                            <li>Improvement in client condition and goals have been accomplished</li>

                        </ul>
                    </ul>
                </p>

                <p className='w-750'><b>Millennium Consulting, LLC maintains business hours from Monday thought Friday 9:00am to 5:00pm - see annual calendar for
                    holiday closings and modified days.</b>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><b>After-hours Crisis Call Number:</b>
                            <input type='text' id='txt' name='txt' className='add-only w-250 custom-add-only' defaultValue='910-346-3853' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='small'>For further information regarding to company policies and procedure or other helpful resources, please refer to the client handbook.</span></td>
                    </tr>
                </table>

                <p className='w-750'><center><h3>Individual Plan of Care Participation/Receipt</h3></center>
                    My signature acknowledges that I have met in person with agency staff to review and discuss my concerns
                    regarding the goals and outcomes represented in the Individual Plan of Care. The goals and clinical direction have met
                    my expectations and I AGREE with the direction of services. I have been given a copy of the Individual Plan of Care.
                </p>

                <p className='w-750'><center><h3>Notification of Client Rights</h3></center>
                    I have read and received a copy of “Your Rights as a Client in your Facility” which is a written summary of 122C, Article 3.
                    I understand its contents regarding client rights and responsibilities and staff have answered my questions.
                    <br /> <br />
                    I also understand that specific programs may have additional policies and procedures pertaining to client rights and these
                    will be explained to me upon entry into the program.
                    <br /> <br />
                    I have received the following information <br /> <br />

                    <ol type='1'>

                        <li>Protection regarding disclosure of confidentiality <br /></li>

                        <li>Procedure for obtaining a copy of my treatment plan <br /></li>

                        <li>Grievance policy/procedures <br /></li>

                        <li>Search and seizure policy notification <br /></li>

                        <li>Notification of permissible client rights regarding restrictive interventions <br /></li>

                        <li>Notification of provisions regarding emergency use of restrictive interventions <br /></li>
                    </ol>
                </p>

                <p className='w-750'><center><h3>Assurance of Confidentiality</h3></center>
                    I understand and agree to comply with the confidentiality regulations and laws of the North Carolina Department
                    of Health and Human Services and Federal Regulations, 42 CFR Part 2 Confidentiality of Alcohol and Drug Abuse
                    Records, to ensure the privileged and confidential nature of all consumer information.
                    <br /><br />
                    In accordance with such regulations, I agree to hold CONFIDENTIAL all information about consumers or former
                    consumers served by Millennium Consulting, LLC, Inc, to which I have access and agree not to divulge such confidential
                    information to unauthorized persons.
                    <br /><br />
                    I also understand that any failure to comply with the provisions of the Confidential Regulations may constitute a
                    misdemeanor punishable by fine or imprisonment and/or may result in suspension or dismissal from employment or other
                    disciplinary actions.
                </p>

                <p className='w-750'><center>Informing Parents/Legal Guardians of Clients Rights</center>
                    <br /><br />
                    The following information has been reviewed with me during orientation:
                    <br /> <br />

                    <ol type='1'>

                        <li>List of Client Rights/Restrictions <br /></li>

                        <li>Policy for Abuse/Neglect of Clients and Reporting <br /></li>

                        <li>Prohibited Interventions <br /></li>

                        <li>HIPAA & Privacy Laws (Confidentiality) <br /></li>

                        <li>Grievance Policy and Procedures  <br /></li>

                    </ol>
                    <br /><br />
                    I understand that:
                    <br /> <br />

                    <ol type='1'>

                        <li> Implementation of approved interventions and rights restriction require following specific procedures. <br /></li>

                        <li>Program designees will be responsible for informing me of specific policies/procedures employed in the program. <br /></li>

                        <li>I must be privileged to authorize of implement any approved interventions or rights restrictions. <br /></li>

                    </ol>

                    <br /><br />
                    I understand and will comply with these rights, policies and procedures. I further understand that non-compliance with
                    this information derived from N.C. Code of Laws Title 44 Chapter 26; Client Rights may result in dismissal and/or legal
                    action.

                </p>

                <p className='w-750'><center><h3>Notice to Consumer Regarding Privacy Practices</h3></center>
                    <br /><br />
                    Millennium Consulting, LLC will maintain sufficient records to justify thorough and appropriate treatment. The information you give
                    is confidential and release or disclosure of any identifiable information to any identifiable information to any individual or agency is
                    prohibited except under the following legal or ethical conditions:

                    <br /> <br />

                    <ol type='1'>

                        <li>Consumer/legal representative has signed a valid authorization for release of information to a third party. (Informed Consent) <br /></li>

                        <li>Consumer is seeking treatment at another facility within the NC Division of Mental Health Developmental Disabilities and
                            Substance Abuse Services and it has been determined to be the consumer&#39;s best interest to disclose information to the
                            facility where consumer is requesting services. (This excludes consumers receiving substance abuse treatment.) <br /></li>

                        <li>Information may be shared with service provider or agency that contracts with Millennium Consulting, LLC (If deemed to be
                            in the best interest of the consumer.) This excludes consumer receiving substance abuse treatment. <br /></li>

                        <li>In the interest of public safety. (It is determined by a clinical staff member that consumer presents a danger to self or others.)<br /></li>

                        <li>In response to court order and/or subpoena.  <br /></li>

                        <li>. In response to a medical emergency, disclosure may be to medical personnel.  <br /></li>

                        <li>State and Federal laws require reporting of child abuse, disabled adult abuse, and any threat to commit such a crime.  <br /></li>

                        <li>Crimes committed at the program. Crimes against any employee of the program, and any threat to commit such a crime.  <br /></li>

                        <li>. In the investigation of life threatening threats to an elected official.  <br /></li>

                        <li>Disclosure may be made to qualified personnel for research, audit, or program evaluation.  <br /></li>

                    </ol>

                    <br /><br />
                    Federal law and regulations protect the confidentiality of alcohol and drug abuse records maintained by this program and violations
                    of the Federal law and regulations by a program are a crime. Suspected violations may be reported to appropriate persons in
                    accordance with federal regulations. (42 CFR, Part 2)
                    <br /><br />
                    Consumer data is maintained in a computerized system for financial, statistical, and program planning purposes. Only authorized
                    staff members have access to this data.

                    <br /><br />
                    As a consumer of Millennium Consulting, LLC, your rights are protected by center policy as well as by state and federal laws. If you
                    have concerns, complaints, or grievance that you wish to express, you are encouraged to discuss them with your clinician; or if you
                    prefer, you may go directly to the supervisor and/or the center&#39;s director as outlined in the Client Grievance Procedure. You also
                    have the right to contact the Civil Rights Division, N.C. DHHS at 1-888-808-4238. We will not discriminate against you for filing a
                    complaint.

                    <br /><br />
                    I FULLY UNDERSTAND THE ABOVE STATEMENTS WHICH HAVE BEEN READ AND EXPLAINED TO ME BY A MEMBER OF THE
                    TREATMENT FACILITYSTAFF AND I HAVE RECEIVED A COPY OF THIS NOTICE; A COPY OF THE MEDICAID APPEALS PROCESS; AND A
                    COPY OF THE NOTICE OF PRIVACY PRACTICES AS REQUIRED BY FEDERAL REGULATIONS. (45 CFR PART 2)
                </p>

                <p className='w-750'><center><h3>Client Grievance Policy</h3></center>

                    <br /><br />
                    <b>POLICY:</b>
                    Millennium Consulting, LLC provides a formal method of reporting and documenting client grievances and complaints. It is
                    imperative that our clients have a means to openly discuss and document issues that are interfering in the recovery process.
                    Millennium Consulting, LLC wants to be informed of any client grievances so that we can resolve issues to the best of our ability.
                    Filing a grievance or complaint will not result in retaliation or barriers to services.
                    <br /> <br />
                    <b>PROCEDURE:</b>
                    We have an obligation to provide a method to address any grievance that you may feel impacts any of your client rights.

                    <br /> <br />

                    <ol type='a'>

                        <li>“Grievance” is defined as “any circumstance for which there is just cause for protest” </li>

                        <li>The grievance procedure at Millennium Consulting, LLC shall be as follows: </li>

                        <ol type='1'>

                            <li>The agency shall provide the client with a written copy of the “grievance procedure” upon admission.</li>

                            <li>The client will sign an acknowledgement form verifying receipt of the Grievance Policy and Procedure, as well as
                                receipt and understanding of the Rights and Responsibilities of each client.</li>

                            <li>Client grievance forms are readily available at all locations upon request.</li>

                            <li>Grievances shall be made to the Site Manager at the administrative office of Millennium Consulting, LLC. If the
                                complaint is made by telephone, Millennium Consulting, LLC personnel will connect the client or family member to
                                the appropriate supervisor. The supervisor will document the complaint either by phone or at a scheduled
                                meeting to assure an understanding of the nature of the grievance. If the grievance involves the agency
                                Supervisor, the staff will contact the Administrator to complete the grievance report.</li>

                            <li>The supervisor is required to investigate, review, and make a written determination of his/her findings including
                                action to be taken to address the complaint within 48 hours of the completion of the written report. A copy of the
                                written report will be given to the client upon completion.</li>

                            <li>The supervisor is required to refer the grievance and his/her report to the Board of Directors</li>

                            <li>. Should the grievance be of such nature that it is reasonable to consider that a legal question has been raised,
                                the administration shall refer the grievance and his/her reports to the attorney of record for the company.</li>

                            <li>On the advice of said attorney, the Administrator shall make the client grievance to the appropriate law
                                enforcement authority.
                            </li>

                            <li>. In all cases, every attempt will be made by all parties to resolve grievances informally within thirty (30) working
                                days.</li>

                            <li>The client has a right at any step of the grievance review process to take his/her grievance directly to:
                            </li>

                            <br />

                            <b><center>Division of MH/DD/SS Advocacy and Consumer Service Section </center></b>
                            <b><center>Phone #: (Toll-free) 800-624-3004 or (Local) 919-855-4500 </center></b>

                            <br />

                            <li>Millennium Consulting, LLC is required to comply with and adhere to the Civil Rights Act of 1964 and all
                                subsequent amendments; including religious, age, sex, and political affiliation as all relate to any and all civil
                                rights which are grated/or implied by statute of law.
                            </li>
                        </ol>
                    </ol>
                </p>

                <p className='w-750'><center><h3>Verification of Consumer Choice</h3></center>
                    <br />
                    I have received information regarding services which I am eligible to receive. I have been informed of providers whom I
                    am eligible to receive such services from. Based upon this information, I have made an informed choice of services and
                    providers listed below.

                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>By completing and signing this form, I choose Millennium Consulting, LLC, Inc. as my provider of choice for</span>
                            <span className='small'>(Please check all the apply).</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbOutpatientTherapy' name='cbOutpatientTherapy' className='add-only' value='OutpatientTherapy' /> Outpatient Therapy</td>
                        <td className='w-187'><input type='checkbox' id='cbPeerSupportServices' name='cbPeerSupportServices' className='add-only' value='PeerSupportServices' /> Peer Support Services</td>
                        <td className='w-375'><input type='checkbox' id='cbDiagnosticAssessmentClinicalAssessment' name='cbDiagnosticAssessmentClinicalAssessment' className='add-only' value='DiagnosticAssessmentClinicalAssessment' /> Diagnostic Assessment/Clinical Assessment</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbConsumerVerificationOther' name='cbConsumerVerificationOther' className='add-only' value='Other' /> Other :
                            <input type='text' id='txtConsumerVerificationOther' name='txtConsumerVerificationOther' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><center><h3>ClientAcknowledgement of 24-hour On-call Services</h3></center></p>

                <p className='w-750'>
                    <b>
                    I, &nbsp; 
                    <input type='text' id='txtClientAcknowledgementName' name='txtClientAcknowledgementName' className='add-only w-250 custom-add-only' placeholder='(Print Name)' /> &nbsp;,&nbsp;
                    <input type='text' id='txtClientAcknowledgementName' name='txtClientAcknowledgementName' className='add-only w-250 custom-add-only' placeholder='(relation, if other than patient)' /> &nbsp;
                    have been informed that Millennium Consulting, LLC provides a 24-hour, 7 days a week
                        emergency telephone number (910-346-3853) for the use of clients or family members in behavioral
                        health crisis situations. On-call personnel are qualified to provide crisis intervention up to and including
                        face-to-face follow-up as necessary, and within his/her scope of practice, for crisis stabilization. I have
                        been given this number and encouraged to post if for emergency accessibility when needed.
                    </b>
                </p>

                <p className='w-750'><center><h3>Patient Acknowledgements Summary</h3></center></p>
                <p className='w-750'><center><h3><b>(Signatures Page)</b></h3></center>
                    <br /><br />
                    My signature acknowledges that I have been informed of my rights and responsibilities as a
                    patient/potential patient of Millennium Consulting, LLC in accordance with, but not limited to the policies,
                    procedures, and/or protocols outlined above.
                </p>

                <table>
                    <tr>
                        <td className='signature w-750'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-750'> Patient / Legally Responsible Person&#39;s Printed Name </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Patient / LRP Signature </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Witness Signature/Title </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>

                <p className='w-750'><center><h3>Informed Consent for Use of Audio/Video Recordings/Photos/Surveillance Cameras</h3></center>
                    <br /><br />
                    Interview or activities recorded by audio, photo, and visual instruments shall be treated with complete confidentiality. It shall
                    be used for the purpose(s) described below only with the written consent of the client and or the client&#39;s guardian. The
                    individual shall be informed of the purpose of recordings and shall be informed when each recording is made. A client may
                    request that taped material be erased at any time.
                    <br /> <br />
                    You are not required to give this permission in order to receive services from Millennium Consulting, LLC. A separate
                    consent form is required for each individual being taped/photo&#39;d. Taped material will be erased after it has been used for
                    the stated purpose(s).
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>I hereby grant Millennium Consulting, LLC permission to use audio, video, and visual tapes of me and/or my family
                            for the purpose(s) of:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtConsultingForAudioVideoUse' name='txtConsultingForAudioVideoUse' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Time-Period for intended use</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtTimePeriodIntendedForUse' name='txtTimePeriodIntendedForUse' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Person(s) or group(s) who may view the recording</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtPersonWhoMayViewRecording' name='txtPersonWhoMayViewRecording' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><center><b>SURVEILLANCE CAMERAS</b></center>
                    <br /><br />
                    Activities recorded by surveillance cameras shall be treated with complete confidentiality and shall be used for treatment
                    and behavior-monitoring purposes. Surveillance cameras shall be mechanical extensions of “line of sight” supervisionrequired, maintaining uninterrupted client supervision. The client and/or legal guardian shall<br /> give written consent for the use
                    of surveillance cameras. Taped material shall be erased after the completion of each <br /> 7-day cycle.

                    <br /> <br />
                    The time-period for intended use of surveillance cameras shall be equivalent to the period of admission through discharge.

                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Person(s) or group(s) who may view the recording</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtPersonOrGroupsWhoMayViewRecording' name='txtPersonOrGroupsWhoMayViewRecording' className='add-only' /></td>
                    </tr>
                </table>

                <table>

                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Consumer/Parent/Guardian Signature </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Witness </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>**Consent Revoked</b></td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Consumer/Parent/Guardian Signature </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <center><h3>Record of Disclosure</h3></center>  
                </p>
                <p className='w-750'> 
                    Notice to Consumer regarding disclosure of pertinent information in the consumer record has been given to client. 
                    <br /> 
                    <center>- Must be completed when consumer information is released/ disclosed -</center>
                </p>

                <table>



                    <tr>
                        <td className='w-150'> <span className='eleHeader'>Date:</span> </td>
                        <td className='w-600'>
                            <span className='eleHeader'>Information Released/Disclosed</span>
                            <span className='small'>(Recipient, Method, & Purpose)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='txtRecordDisclosureDate_1' name='txtRecordDisclosureDate_1' className='add-only' /> </td>
                        <td className='w-600'>
                            Released to: <input type='text' id='txtRecordDisclosureReleaseTo_1' name='txtRecordDisclosureReleaseTo_1' className='add-only w-200 custom-add-only' /> &nbsp;
                            Purpose: <input type='text' id='txtRecordDisclosurePurpose_1' name='txtRecordDisclosurePurpose_1' className='add-only w-200 custom-add-only' />
                            <br />

                            Method:
                            <input type='checkbox' id='cbRecordDisclosureMethodFaxed_1' name='cbRecordDisclosureMethodFaxed_1' className='add-only' value='Faxed' /> Faxed  &nbsp;
                            <input type='checkbox' id='cbRecordDisclosureMethodMail_1' name='cbRecordDisclosureMethodMail_1' className='add-only' value='Mail' /> Mail
                        </td>
                    </tr>

                    <tr>
                        <td className='signature w-750'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-750'> Signature </td>
                    </tr>



                    <tr>
                        <td className='w-150'> <span className='eleHeader'>Date:</span> </td>
                        <td className='w-600'>
                            <span className='eleHeader'>Information Released/Disclosed</span>
                            <span className='small'>(Recipient, Method, & Purpose)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='txtRecordDisclosureDate_2' name='txtRecordDisclosureDate_2' className='add-only' /> </td>
                        <td className='w-600'>
                            Released to: <input type='text' id='txtRecordDisclosureReleaseTo_2' name='txtRecordDisclosureReleaseTo_2' className='add-only w-200 custom-add-only' /> &nbsp;
                            Purpose: <input type='text' id='txtRecordDisclosurePurpose_2' name='txtRecordDisclosurePurpose_2' className='add-only w-200 custom-add-only' />
                            <br />

                            Method:
                            <input type='checkbox' id='cbRecordDisclosureMethodFaxed_2' name='cbRecordDisclosureMethodFaxed_2' className='add-only' value='Faxed' /> Faxed  &nbsp;
                            <input type='checkbox' id='cbRecordDisclosureMethodMail_2' name='cbRecordDisclosureMethodMail_2' className='add-only' value='Mail' /> Mail
                        </td>
                    </tr>

                    <tr>
                        <td className='signature w-750'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-750'> Signature </td>
                    </tr>




                    <tr>
                        <td className='w-150'> <span className='eleHeader'>Date:</span> </td>
                        <td className='w-600'>
                            <span className='eleHeader'>Information Released/Disclosed</span>
                            <span className='small'>(Recipient, Method, & Purpose)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='txtRecordDisclosureDate_3' name='txtRecordDisclosureDate_3' className='add-only' /> </td>
                        <td className='w-600'>
                            Released to: <input type='text' id='txtRecordDisclosureReleaseTo_3' name='txtRecordDisclosureReleaseTo_3' className='add-only w-200 custom-add-only' /> &nbsp;
                            Purpose: <input type='text' id='txtRecordDisclosurePurpose_3' name='txtRecordDisclosurePurpose_3' className='add-only w-200 custom-add-only' />
                            <br />

                            Method:
                            <input type='checkbox' id='cbRecordDisclosureMethodFaxed_3' name='cbRecordDisclosureMethodFaxed_3' className='add-only' value='Faxed' /> Faxed  &nbsp;
                            <input type='checkbox' id='cbRecordDisclosureMethodMail_3' name='cbRecordDisclosureMethodMail_3' className='add-only' value='Mail' /> Mail
                        </td>
                    </tr>

                    <tr>
                        <td className='signature w-750'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-750'> Signature </td>
                    </tr>



                    <tr>
                        <td className='w-150'> <span className='eleHeader'>Date:</span> </td>
                        <td className='w-600'>
                            <span className='eleHeader'>Information Released/Disclosed</span>
                            <span className='small'>(Recipient, Method, & Purpose)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='txtRecordDisclosureDate_4' name='txtRecordDisclosureDate_4' className='add-only' /> </td>
                        <td className='w-600'>
                            Released to: <input type='text' id='txtRecordDisclosureReleaseTo_4' name='txtRecordDisclosureReleaseTo_4' className='add-only w-200 custom-add-only' /> &nbsp;
                            Purpose: <input type='text' id='txtRecordDisclosurePurpose_4' name='txtRecordDisclosurePurpose_4' className='add-only w-200 custom-add-only' />
                            <br />

                            Method:
                            <input type='checkbox' id='cbRecordDisclosureMethodFaxed_4' name='cbRecordDisclosureMethodFaxed_4' className='add-only' value='Faxed' /> Faxed  &nbsp;
                            <input type='checkbox' id='cbRecordDisclosureMethodMail_4' name='cbRecordDisclosureMethodMail_4' className='add-only' value='Mail' /> Mail
                        </td>
                    </tr>

                    <tr>
                        <td className='signature w-750'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-750'> Signature </td>
                    </tr>


                    <tr>
                        <td className='w-150'> <span className='eleHeader'>Date:</span> </td>
                        <td className='w-600'>
                            <span className='eleHeader'>Information Released/Disclosed</span>
                            <span className='small'>(Recipient, Method, & Purpose)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='txtRecordDisclosureDate_5' name='txtRecordDisclosureDate_5' className='add-only' /> </td>
                        <td className='w-600'>
                            Released to: <input type='text' id='txtRecordDisclosureReleaseTo_5' name='txtRecordDisclosureReleaseTo_5' className='add-only w-200 custom-add-only' /> &nbsp;
                            Purpose: <input type='text' id='txtRecordDisclosurePurpose_5' name='txtRecordDisclosurePurpose_5' className='add-only w-200 custom-add-only' />
                            <br />

                            Method:
                            <input type='checkbox' id='cbRecordDisclosureMethodFaxed_5' name='cbRecordDisclosureMethodFaxed_5' className='add-only' value='Faxed' /> Faxed  &nbsp;
                            <input type='checkbox' id='cbRecordDisclosureMethodMail_5' name='cbRecordDisclosureMethodMail_5' className='add-only' value='Mail' /> Mail
                        </td>
                    </tr>

                    <tr>
                        <td className='signature w-750'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-750'> Signature </td>
                    </tr>

                </table>



                <p className='w-750'><center><h3>Consent for Release of Protected Health Information</h3></center>
                    <br /><br />
                    <center><b>- This is a legal document and will not be honored unless it is completed in full. -</b></center>
                    <br />
                    <center>I hereby authorize information to be released to and/or from/with:</center>
                    <br />
                    <center><b>Millennium Consulting, LLC</b></center>
                    <center><b>2407 W 5th St</b></center>
                    <center><b>Lumberton, NC 28358</b></center>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Agency Name and Address:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtAgencyNameAddress' name='txtAgencyNameAddress' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><center><b>- Individual/Guardian Initial Next to Authorized Information -</b></center></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Type of Release/ Disclosure</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbReleaseRecords' name='cbReleaseRecords' className='add-only' value='ReleaseRecords' /> Release Records</td>
                        <td className='w-250'><input type='checkbox' id='cbReceiveRecords' name='cbReceiveRecords' className='add-only' value='ReceiveRecords' /> Receive Records</td>
                        <td className='w-250'><input type='checkbox' id='cbShareInformation' name='cbShareInformation' className='add-only' value='ShareInformation' /> Share information</td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Information shall include</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbCorrespondencesDisclosures' name='cbCorrespondencesDisclosures' className='add-only' value='CorrespondencesDisclosures' /> Correspondences/Disclosures</td>
                        <td className='w-250'><input type='checkbox' id='cbServiceTreatmentNotes' name='cbServiceTreatmentNotes' className='add-only' value='ServiceTreatmentNotes' /> Service/Treatment Notes</td>
                        <td className='w-250'><input type='checkbox' id='cbMedicationInformation' name='cbMedicationInformation' className='add-only' value='MedicationInformation' /> Medication Information</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbDrugTestResults' name='cbDrugTestResults' className='add-only' value='DrugTestResults' /> Lab/Drug Test Results</td>
                        <td className='w-250'><input type='checkbox' id='cbDischargeSummary' name='cbDischargeSummary' className='add-only' value='DischargeSummary' /> Discharge Summary</td>
                        <td className='w-250'><input type='checkbox' id='cbServiceTreatmentPlan' name='cbServiceTreatmentPlan' className='add-only' value='ServiceTreatmentPlan' /> Service/Treatment Plan</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbPsychologicalPsychiatricEvaluation' name='cbPsychologicalPsychiatricEvaluation' className='add-only' value='PsychologicalPsychiatricEvaluation' /> Psychological/Psychiatric Evaluation</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbInformationShallIncludeOther' name='cbInformationShallIncludeOther' className='add-only' value='InformationShallIncludeOther' /> Other: &nbsp;
                            <input type='text' id='txtInformationShallIncludeOther' name='txtInformationShallIncludeOther' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Reason for Release </span>
                            <span className='small'>(Purpose):</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbContinuityCare' name='cbContinuityCare' className='add-only' value='ContinuityCare' /> Continuity of Care</td>
                        <td className='w-375'><input type='checkbox' id='cbDeterminationSecuringBenefits' name='cbDeterminationSecuringBenefits' className='add-only' value='DeterminationSecuringBenefits' /> Determination of/Securing Benefits</td>

                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbRequestIndividual' name='cbRequestIndividual' className='add-only' value='RequestIndividual' /> At the Request of individual</td>
                        <td className='w-375'><input type='checkbox' id='cbRequestGuardian' name='cbRequestGuardian' className='add-only' value='RequestGuardian' /> At the Request of the Guardian</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbLegalRepresentation' name='cbLegalRepresentation' className='add-only' value='LegalRepresentation' /> Legal Representation</td>
                        <td className='w-375'><input type='checkbox' id='cbDevelopmentServices' name='cbDevelopmentServices' className='add-only' value='DevelopmentServices' /> Development of Services</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbEvaluation' name='cbEvaluation' className='add-only' value='Evaluation' /> Evaluation</td>
                        <td className='w-375'><input type='checkbox' id='cbPsychologicalPsychiatricEvaluation' name='cbPsychologicalPsychiatricEvaluation' className='add-only' value='PsychologicalPsychiatricEvaluation' /> Psychological/Psychiatric Evaluation</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbReasonReleaseOther' name='cbReasonReleaseOther' className='add-only' value='ReasonReleaseOther' /> Other: &nbsp;
                            <input type='text' id='txtReasonReleaseOther' name='txtReasonReleaseOther' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><center><b>*If you consent to the following sensitive information being disclosed, initial the applicable space(s) below:</b></center></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbPsychologicalPsychiatricEvaluation' name='cbPsychologicalPsychiatricEvaluation' className='add-only' value='PsychologicalPsychiatricEvaluation' /> Sexually Transmitted Diseases</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbEvaluation' name='cbEvaluation' className='add-only' value='Evaluation' /> Alcohol/Drug Abuse Treatment/Referral</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbEvaluation' name='cbEvaluation' className='add-only' value='Evaluation' /> HIV / AIDS-related Information</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbPsychologicalPsychiatricEvaluation' name='cbPsychologicalPsychiatricEvaluation' className='add-only' value='PsychologicalPsychiatricEvaluation' /> Mental Health/Psychiatric/Psychological Assessment / Evaluations <span className='small'>(Includes Diagnosis, Social, Developmental & Medical History)</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbEvaluation' name='cbEvaluation' className='add-only' value='Evaluation' /> Psychotherapy Notes ONLY <b>(by initialing this space, I am waiving any psychotherapist-patient privilege)</b></td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>This Consent shall be valid for one year. Expires on &nbsp;</b> <input type='date' id='txtConsentExpiresDate' name='txtConsentExpiresDate' className='add-only w-150 custom-add-only' /> &nbsp; <b>Not to exceed one year.</b></td>
                    </tr>

                </table>

                <p className='w-750'><center><b>I acknowledge that Millennium Consulting, LLC has not conditioned my treatment on signing this authorization. I understand that I cannot be
                    denied or refused treatment, payment or eligibility for benefits based on my refusal to sign.
                    <br /><br />
                    I understand that HIPAA privacy law (42 CFR Part 2) protecting health information may not apply to the recipient of the information for which I
                    signed in the above release when Millennium Consulting, LLC discloses mental health, developmental disability, or substance abuse information
                    protected by state law (N.C. Code of Laws Title 42 Chapter 26; 42 CFR Part 2). Millennium Consulting, LLC informs the recipient of the
                    information that re- disclosure is prohibited, except as permitted or required by above mentioned laws. Millennium Consulting, LLC&#39;s Notice of
                    Privacy describesthe circumstances under which disclosure is permitted or required by law.
                    <br /><br />
                    I understand that I may revoke this authorization at any time except to the extent that action has been in reliance on it. If revoking this
                    authorization, I must do so in writing by submitting a signed revocation statement to the Qualified Professional overseeing services.
                </b></center></p>

                <table>
                    <tr>
                        <td className='signature w-750'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Printed Name </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Relation</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbPatient' name='cbPatient' className='add-only' value='Patient' /> Patient</td>
                        <td className='w-250'><input type='checkbox' id='cbParent' name='cbParent' className='add-only' value='Parent' /> Parent</td>
                        <td className='w-250'><input type='checkbox' id='cbGuardian' name='cbGuardian' className='add-only' value='Guardian' /> Guardian</td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Signature </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='w-750'><center><b>*Individual mustshow documentation of guardianship/ legally responsible <br />(ex. POA or documentation from DSS).</b></center></td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Witness Signature </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>

            </div>
        </form>

    )
}











